import React, { useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Controller } from "react-hook-form";

const PasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const { control, getValues } = props.formController;
  return (
    <Controller
      name="password"
      control={control}
      defaultValue=""
      rules={{ required: "Password is required." }}
      render={({ field, fieldState }) => {
        return (
          <TextField
            label={props.label}
            autoComplete="password"
            type={showPassword ? "text" : "password"}
            required={true}
            error={fieldState.error !== undefined}
            helperText={fieldState.error ? "Password is required" : ""}
            {...props.register("password", { required: true })}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            {...field}
          />
        );
      }}
    />
  );
};

export default PasswordInput;
